import type { Config } from './types'


const config: Config = (() => {
  if (__SERVER__) {
    return require('./server').default
  }

  return require('./client').default
})()


export default config
